import moment from 'moment';

export const VARIABLE = 'VARIABLE';
export const EXPERIMENT = 'EXPERIMENT';
export const ROLLOUT = 'ROLLOUT';
export const EVENT = 'EVENT';
export const FLEXIBLEEXP = 'flexible-exp';
export const XSCHEDULER = 'x-scheduler';
export const ISADMINKEY = 'isAdmin';
export const BETA_KEY = 'beta';
export const DOMAIN = 'domain';

export const OPERATORSTARTAFTER = 'start_after';
export const OPERATORALLOW = 'allow';
export const OPERATORDISALLOW = 'disallow';

export const COMPLETED = 'COMPLETED';
export const CANCELLED = 'CANCELLED';
export const UNKNOWN = 'UNKNOWN';
export const REQUESTED = 'REQUESTED';
export const SCHEDULED = 'SCHEDULED';
export const STARTED = 'STARTED';
export const PAUSED = 'PAUSED';
export const ABORTED = 'ABORTED';
export const RUNNING = 'RUNNING';

export const PENDING_METRICS = 'PENDING_METRICS';

export const ADAPTIVE = 'ADAPTIVE_EXPERIMENT';
export const AB = 'EXPERIMENT';

export const ADAPTIVE_EXPERIMENTS_BY_PRODUCTS = [
  {
    state: 'COMPLETED',
    name: 'exp_a',
    product: 'testp2',
    owner: 'bjorn.jee@grabtaxi.com',
    createdAt: `${moment('2022-07-12T02:33:15Z').format('lll')} (SGT)`,
  },
  {
    state: 'COMPLETED',
    name: 'exp_c',
    product: 'testp2',
    owner: 'bjorn.jee@grabtaxi.com',
    createdAt: `${moment('2022-07-12T02:33:15Z').format('lll')} (SGT)`,
  },
  {
    state: 'COMPLETED',
    name: 'exp_d',
    product: 'testp2',
    owner: 'bjorn.jee@grabtaxi.com',
    createdAt: `${moment('2022-07-12T02:33:15Z').format('lll')} (SGT)`,
  },
];

export const PRODUCTS = [
  {
    NAME: 'batching',
    COMPLETED: { count: 0 },
    RUNNING: { count: 0 },
    PENDING: { count: 0 },
    CANCELLED: { count: 0 },
  },
  {
    NAME: 'delayed_allocation',
    COMPLETED: { count: 0 },
    RUNNING: { count: 0 },
    PENDING: { count: 0 },
    CANCELLED: { count: 0 },
  },
  {
    NAME: 'priority_allocation',
    COMPLETED: { count: 0 },
    RUNNING: { count: 0 },
    PENDING: { count: 0 },
    CANCELLED: { count: 0 },
  },
];

export const METRIC_COLLECTION_IDS = {
  srmExpLevelDailyStats: 'srm-exp-level-daily-stats',
};

export const METRIC_NAMES = {
  srmPVal: 'srm_p_val',
};

export { HTTP_STATUS } from '../constants/http';

export const MIDAS_METRICS_ENDPOINT = 'https://midas.grab.com/metrics';

export * from './variable';
export * from './featureFlags';

export const GRABX_SLACK_CHANNEL = 'https://grab.slack.com/messages/C543VR9HT';
